import api from '../api/client';

const getAll = async () => {
    const res = await api.get('/api/application/get-all-apps');
    return res?.data?.data;
};

// User-scoped: returns only the caller's own apps (all apps for portal admins).
const getMine = async () => {
    const res = await api.get('/api/application/get-my-apps');
    return res?.data?.data;
};

// Server-paged list for the Apps table: resolves { results, pagination }.
// `mine` pages /get-my-apps (app-scoped callers); otherwise /get-all-apps (portal admin).
// getAll/getMine stay unpaged for AppsContext and the app selector dropdowns.
const getPage = async (query, { mine = false } = {}) => {
    const url = mine ? '/api/application/get-my-apps' : '/api/application/get-all-apps';
    const res = await api.get(url, { params: query });
    return res?.data?.data;
};

// Public (pre-auth): minimal [{ app_id, app_name }] for the login-page app dropdown.
const getPublicList = async () => {
    const res = await api.get('/api/application/public-list');
    return res?.data?.data || [];
};

const updateAppDetails = async (appId, payload) => {
    const res = await api.post('/api/application/update-app-details', payload, { params: { app_id: appId } });
    return res?.data;
};

const createApp = async (payload) => {
    const res = await api.post('/api/reg/registerNewApp', payload);
    return res?.data;
};

const deleteApp = async (appId) => {
    const res = await api.delete('/api/application/delete-app', { params: { app_id: appId } });
    return res?.data;
};

const updateAppStatus = async (appId, isActive) => {
    const res = await api.post('/api/application/update-app-status', {
        app_id: appId,
        is_active: isActive ? 1 : 0,
    });
    return res?.data;
};

const getSigningKeys = async (appId) => {
    const res = await api.get(`/api/application/signing-keys?app_id=${appId}`);
    return res?.data?.data;
};

// Active-user seat usage for an app (and tenant, when tenantId supplied).
const getSeatUsage = async (appId, tenantId = null) => {
    const params = { app_id: appId };
    if (tenantId) params.tenant_id = tenantId;
    const res = await api.get('/api/application/seat-usage', { params });
    return res?.data?.data;
};

const generateSigningKey = async (appId, secretType) =>
    api.post('/api/application/signing-keys/generate', { app_id: appId, secret_type: secretType });

const rotateSigningKey = async (appId, secretType) =>
    api.post('/api/application/signing-keys/rotate', { app_id: appId, secret_type: secretType });

const removeSigningKey = async (appId, secretType) =>
    api.delete('/api/application/signing-keys', { data: { app_id: appId, secret_type: secretType } });

const appsService = {
    getAll,
    getMine,
    getPage,
    getPublicList,
    updateAppDetails,
    createApp,
    deleteApp,
    updateAppStatus,
    getSigningKeys,
    generateSigningKey,
    rotateSigningKey,
    removeSigningKey,
    getSeatUsage,
};

export default appsService;
